<template>
  <div>
    <!-- BCIS CALCULATED HELP TEXT -->
    <p>
      £{{ rebuildCostFormatted.expectedFormatted }} is the average rebuild cost of your {{ propertyName }},
      as calculated by the Building Cost Information Service.
      <span v-if="!isRebuildHelpTextShowMore">
        While this is a reasonable estimate, you should adjust if you feel the cost will be higher or lower than this average.
        <a
          class="d-block text-decoration-underline"
          href="#"
          @click.prevent="isRebuildHelpTextShowMore = true"
        >How is this calculated?</a>
      </span>
    </p>
    <template v-if="isRebuildHelpTextShowMore">
      <p>
        This estimate is based on details such as your {{ propertyName }}’s size, location and age, however the cost of
        rebuilding a {{ rooms }}-room house can range from £{{ rebuildCostFormatted.min }} for a smaller house of basic
        quality to £{{ rebuildCostFormatted.max }} for a larger, excellent quality house.
        <a
          class="text-decoration-underline"
          href="#"
          @click.prevent="isRebuildHelpTextShowMore = false"
        >
          How is this calculated?
        </a>
      </p>
      <p>
        If unsure, you may wish to obtain professional advice or consult your mortgage valuation documents, surveyors
        report or previous insurance documents. If your {{ propertyName }} is found to be underinsured in the event
        of a claim, your insurer may not settle the full claim.
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'house-rebuild-help-text',
  inject: [
    'helpers',
    'productName',
  ],
  props: {
    rebuildCost: {
      type: Object,
      default: () => {},
    },
    rooms: {
      type: [Number, undefined],
      default: undefined,
    },
  },
  data () {
    return {
      isRebuildHelpTextShowMore: false,
    };
  },
  computed: {
    // formattedNumber {String} e.g. '100,000'
    /* template rebuildCostFormatted: {
      expectedFormatted: formattedNumber,
      expected: formattedNumber,
      min: formattedNumber,
      max: formattedNumber,
    }; */
    rebuildCostFormatted () {
      return Object.keys(this.rebuildCost).reduce((formatted, key) => {
        formatted[key] = this.helpers.getNumberFormatted(this.rebuildCost[key]);
        return formatted;
      }, {});
    },
    propertyName () {
      return this.productName === 'home' ? 'home' : 'property';
    },
  },
};
</script>
